import { render, staticRenderFns } from "./ListProductCatalog.vue?vue&type=template&id=5218b97c&scoped=true&"
import script from "./ListProductCatalog.vue?vue&type=script&lang=js&"
export * from "./ListProductCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5218b97c",
  null
  
)

export default component.exports